import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import PropTypes from 'prop-types';
import {get} from 'lodash';
import appActions from '../../actions/actions';
import businessModelActions from '../../actions/businessModel';
import BusinessModel from './BusinessModel';
import { MERCHANT_OF_RECORD } from '../../utils/constants';

function mapStateToProps(state) {
    return {
        publicUuid: get(state, 'app.publicUuid', ''),
        translations: state.app.translations,
        businessModelChoice: get(state, 'businessModel.businessModelChoice', ''),
        enableBusinessModelContinueBtn: get(state, 'businessModel.enableBusinessModelContinueBtn', false),
        serviceError: get(state, 'businessModel.serviceError', '')
    };
}

function mapDispatchToProps(dispatch) {
    return {
        appActions: bindActionCreators(appActions, dispatch),
        businessModelActions: bindActionCreators(businessModelActions, dispatch),
        dispatch
    };
}

@connect(mapStateToProps, mapDispatchToProps)
export default class BusinessModelContainer extends React.Component {
    constructor(props) {
        super(props);
    }

    componentWillMount() {
        this.props.appActions.enableLoadOverLay(false);
    }

    triggerEdapPageViewAction = () => this.props.appActions.triggerEdapPageView(this.props.publicUuid, 'Business Model');

    handleChoiceChange = (event) => {
        this.props.businessModelActions.setBusinessModelChoice(event.target.value);
        this.props.businessModelActions.toggleContinueButtonView();
        this.props.appActions.triggerEdapEvent('generic.event', {
                    eventcategory: (event.target.value === MERCHANT_OF_RECORD.SUPPLIER) ? 'SUPPLIER model selected' : 'EG as merchant of record selected',
                    eventaction: 'Business model selected',
                    highfrequency: 'true'
        }, {});
    }

    handleNextButtonClick = (event) => {
        event.preventDefault();

        this.props.appActions.triggerEdapEvent('generic.click', {
                    eventcategory: 'Continue'
        }, {});
        this.props.appActions.enableLoadOverLay(true);
        this.props.businessModelActions.submitBusinessModel(this.props.businessModelChoice);
    }

    handleAlertDismiss = () => {
        this.props.businessModelActions.alertError('');
    }

    render() {
        return (
            <BusinessModel
                publicUuid={this.props.publicUuid}
                triggerEdapPageViewAction={this.triggerEdapPageViewAction}
                translations={this.props.translations}
                businessModelChoice={this.props.businessModelChoice}
                handleChoiceChange={this.handleChoiceChange}
                enableBusinessModelContinueBtn={this.props.enableBusinessModelContinueBtn}
                handleNextButtonClick={this.handleNextButtonClick}
                serviceError={this.props.serviceError}
                handleAlertDismiss={this.handleAlertDismiss}
            />
        );
    }
}

BusinessModelContainer.propTypes = {
    publicUuid: PropTypes.string,
    translations: PropTypes.any, // eslint-disable-line react/forbid-prop-types
    businessModelChoice: PropTypes.string,
    enableBusinessModelContinueBtn: PropTypes.bool,
    serviceError: PropTypes.string,
    appActions: PropTypes.object, // eslint-disable-line react/forbid-prop-types
    businessModelActions: PropTypes.object, // eslint-disable-line react/forbid-prop-types
    dispatch: PropTypes.func
};

BusinessModelContainer.defaultProps = {
    publicUuid: '-1',
};
